import { render, staticRenderFns } from "./SongwriterCreateButton.vue?vue&type=template&id=34a97a84"
import script from "./SongwriterCreateButton.vue?vue&type=script&lang=js"
export * from "./SongwriterCreateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports